const APP_ENV = process.env.NEXT_PUBLIC_APP_ENV
export const ENVIRONMENT = {
  isDevelopment: APP_ENV === 'development',
  isProduction: APP_ENV === 'production',
  isStaging: APP_ENV === 'staging',
}
export const CLAYTON_WORKSPACE_ID = 'f119dd7f-9766-4e83-8760-9a0a28e80bb9'
export const CALENDLY_LINK = ENVIRONMENT.isProduction
  ? 'https://calendly.com/gearset/clayton-from-gearset-consultation'
  : 'https://calendly.com/d/cpt3-crn-xvm/test-clayton-in-app-talk-to-sales'
export const INTERCOM_APP_ID = ENVIRONMENT.isProduction
  ? 'unllmz0z'
  : ENVIRONMENT.isStaging
    ? 'lh3u8knr'
    : undefined

export const DEFAULT_DRAFT_POLICY_NAME = 'Draft Policy'
export const DEFAULT_POLICY_INSTALLATION_STATUSES = [
  'DISABLED',
  'ENABLED_OPT_IN',
  'ENABLED_OPT_OUT',
  'ENABLED_MANDATORY',
]
export const DRAWER_WIDTHS = {
  PERCENTAGE70: '70%',
  PERCENTAGE40: '40%',
  PERCENTAGE60: '60%',
  PERCENTAGE30: '30%',
  LARGE: 800,
  MEDIUM: 640,
  SMALL: 480,
}

export const DEFAULT_PAGE_SIZE = 9

export const DEFAULT_SMALL_PAGE_SIZE = 6

export const EMPTY_TABLE_MIN_HEIGHT = '30vh'

export const NO_DATA_PLACEHOLDER = '__no_data__' // used in translations to let intl select operator know that no search term was provided

export const NONE = 'NONE' // used in querystring to indicate that nothing was selected and override default behavior

export const POLLING_INTERVALS_MS = {
  '1s': 1000,
  '3s': 3000,
  '15s': 15000,
  '30s': 30000,
  '60s': 60000,
  '90s': 90000,
  '180s': 180000,
}

export const TOOLBAR_FIELD_STYLE = { minWidth: '280px', width: '100%' }

export const TOOLBAR_FIELD_STYLE_SMALL = { minWidth: '140px', width: '100%' }

export const REFRESH_INTERVAL_ARR = Array.from({ length: 8 }, (_, i) =>
  Math.pow(i + 1, 2)
).map((value) => value * 1000)

export const TABLE_COLUMNS_WIDTHS = {
  ACTIONS_1BUTTON: 64,
  ACTIONS_2BUTTONS: 100,
  ACTIONS_3BUTTONS: 176,
  AVATAR: 64,
  DATE: 128,
  MEDIUM: 128,
  NUMBER_3DIGITS: 176,
  LARGE: 174,
  SMALL: 96,
}

export enum AlignTypes {
  CENTER = 'center',
  LEFT = 'left',
  RIGHT = 'right',
}
